export default "__VITE_ASSET__501a1d02__"